import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { Section, Container } from "../components/ui";
import styles from "./MentionsLegales.module.css";

export function MentionsLegales() {
  const { t } = useTranslation('legal');

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />

      <Section variant="dark" className={styles.hero}>
        <Container>
          <div className={styles.heroContent}>
            <h1>{t('hero.title')}</h1>
            <p className={styles.heroSubtitle}>{t('hero.subtitle')}</p>
          </div>
        </Container>
      </Section>

      <Section variant="light">
        <Container>
          <div className={styles.content}>
            <p>{t('intro')}</p>

            <h2>{t('editor.title')}</h2>
            <p>
              {t('editor.text')}{" "}
              <strong>{t('editor.company')}</strong>.
            </p>
            <p>
              <strong>{t('editor.capitalLabel')}</strong> {t('editor.capital')}
              <br />
              <strong>{t('editor.hqLabel')}</strong> {t('editor.hq')}
              <br />
              <strong>{t('editor.regLabel')}</strong> {t('editor.reg')}
              <br />
              <strong>{t('editor.vatLabel')}</strong> {t('editor.vat')}
              <br />
              <strong>{t('editor.directorLabel')}</strong> {t('editor.director')}
              <br />
              <strong>{t('editor.contactLabel')}</strong>{" "}
              <a href="mailto:partners@qbp.solutions">partners@qbp.solutions</a>
              <br />
              <strong>{t('editor.phoneLabel')}</strong>{" "}
              <a href="tel:+33279655611">+33 (0)2 79 65 56 11</a>
            </p>

            <h2>{t('hosting.title')}</h2>
            <p>
              {t('hosting.text')} <strong>{t('hosting.company')}</strong>, {t('hosting.details')}
            </p>
            <p>
              <strong>{t('hosting.nameLabel')}</strong> {t('hosting.name')}
              <br />
              <strong>{t('hosting.hqLabel')}</strong> {t('hosting.hq')}
              <br />
              <strong>{t('hosting.regLabel')}</strong> {t('hosting.reg')}
              <br />
              <strong>{t('hosting.capitalLabel')}</strong> {t('hosting.capital')}
            </p>

            <h2>{t('ip.title')}</h2>
            <p>{t('ip.text')}</p>
            <h3>{t('ip.trademarksTitle')}</h3>
            <p>{t('ip.trademarks')}</p>
            <h3>{t('ip.contentTitle')}</h3>
            <p>{t('ip.content')}</p>
            <h3>{t('ip.conceptTitle')}</h3>
            <p>{t('ip.concept')}</p>

            <h2>{t('gdpr.title')}</h2>
            <p>{t('gdpr.intro')}</p>
            <p><strong>{t('gdpr.purposeLabel')}</strong> {t('gdpr.purpose')}</p>
            <p><strong>{t('gdpr.controllerLabel')}</strong> {t('gdpr.controller')}</p>
            <p><strong>{t('gdpr.legalBasisLabel')}</strong> {t('gdpr.legalBasis')}</p>
            <p>
              <strong>{t('gdpr.rightsLabel')}</strong> {t('gdpr.rights')}{" "}
              <a href="mailto:partners@qbp.solutions">partners@qbp.solutions</a>.
            </p>
            <p><strong>{t('gdpr.retentionLabel')}</strong> {t('gdpr.retention')}</p>

            <h2>{t('cookies.title')}</h2>
            <p>{t('cookies.text')}</p>

            <h2>{t('liability.title')}</h2>
            <p>{t('liability.intro')}</p>
            <p>{t('liability.p1')}</p>
            <p>{t('liability.p2')}</p>
            <p>{t('liability.p3')}</p>

            <h2>{t('jurisdiction.title')}</h2>
            <p>{t('jurisdiction.text')}</p>

            <p className={styles.lastUpdate}>{t('lastUpdate')}</p>
          </div>
        </Container>
      </Section>
    </>
  );
}
